import React, { useMemo } from 'react';
import { GeoJSONLayer } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { hexToRgba } from '../../../common/formatters/colorFormatter';
import { GeometryExact } from '../../models/Geometry';

const Coverage = ({ index, geometry, visible }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: visible ? geometry : undefined,
    }),
    [visible, geometry]
  );

  return (
    <GeoJSONLayer
      id={`coverage${index}`}
      data={sourceData}
      fillPaint={{
        'fill-color': hexToRgba(theme.palette.map.coverage, 0.4),
        'fill-outline-color': theme.palette.map.coverage,
      }}
    />
  );
};

Coverage.propTypes = {
  geometry: GeometryExact,
  index: PropTypes.number,
  visible: PropTypes.bool,
};

Coverage.defaultProps = {
  geometry: undefined,
  index: 0,
  visible: true,
};

export default React.memo(Coverage);
